import { useFlags } from 'launchdarkly-react-client-sdk';

export interface SupportedLocale {
  text: string;
  value: string;
}

export const useSupportedLocales = () => {
  const flags = useFlags();

  const locales: (SupportedLocale | null)[] = [
    { value: 'en-GB', text: 'en-GB' },
    { value: 'fr-FR', text: 'fr-FR' },
    flags.switchLocaleFrenchCanada ? { value: 'fr-CA', text: 'fr-CA' } : null,
    flags.switchLocaleTesting ? { value: 'en-test1', text: 'English~' } : null,
    flags.switchLocaleTesting ? { value: 'en-test2', text: 'English@' } : null
  ];

  return locales.filter(l => !!l) as SupportedLocale[];
};
